import React, {useEffect, useState} from 'react'
import {compose} from "redux";
import Footer from "../../components/Footer";
import WithSettings from "../../components/HOC/WithSettings";
import {bootstrapCodeActivation, bootstrapRegistration, bootstrapSplash, headerEnrichment, resetRegistration, setAuthorized, setHeaderEnrichmentData} from "../../redux/actions/authActions";
import WithAuth from "../../components/HOC/WithAuth";
import { jsonToFormData, localize, one10LabsCall, resetLoginParam, setHintDialog} from "../../helpers/functions";
import {useSelector} from "react-redux";
import {
    appVersion,
    currentOperation,
    deviceLanguage,
    deviceType,
    isheaderEnrichment,
    isYabadooOperation,
    osName,
    osVersion,
    phoneNumber,
    privacyPolicyURL,
    referralEnabled,
    useragent
} from "../../helpers/constants";
import {loadingImages, loginBackground, wideLogo} from "../../assets/img/exports";
import {navigate} from "@reach/router";
import {Routes} from "../AppRouter";
import {countryOperator, localStorageKeys, operations} from "../../helpers/enums";
import firebase from "firebase/app";
import '@firebase/messaging';
import {Select} from "antd";
import store from "../../redux/store";
import axios from "axios";
import{FaPlay} from "react-icons/fa";
import {setHeaderFetching} from "../../redux/actions/settingsActions";
import PrivacyPolicy from "../PrivacyPolicy";

const Login = props => {
    const [phone, setPhone] = useState(phoneNumber.prefix)
    const verificationCode = useSelector(state => state.player.code)
    const number = useSelector(state => state.auth.number)
    const [code, setCode] = useState('')
    const auth = useSelector(state => state.auth)
    const [focus, setfocus] = useState(false)
    const bg = loginBackground
    // const operation = localStorage.getItem(localStorageKeys.currentOperation)
    const operation = localStorage.getItem(localStorageKeys.operatorName)
    const {errorVisible} = useSelector(state => state.services)
    const [check,setCheck] = useState(false)
    const [referral,setReferral] = useState('')
    const [headEnr,setHeadEnr] = useState(true)

    const [countryName, setcountryName] = useState(localStorage.getItem(localStorageKeys.countryName))
    const [operatorName, setoperatorName] = useState(localStorage.getItem(localStorageKeys.operatorName))

    const codeReceived = !!verificationCode && isheaderEnrichment && !auth.authorized
    const fetch = useSelector(state => state.player.fetch)
    const {resetLogin,headerFetching} = useSelector(state => state.settings)
    const referralReciv = localStorage.getItem(localStorageKeys.recevReferral)

    useEffect(() => {
        if(!!referralReciv){
            setCheck(true)
            setReferral(referralReciv)
        }
        if(resetLogin){
            resetLoginParam(false)
            resetRegister()
        }
    },[referralReciv,resetLogin])


    useEffect(() => {
        setfocus(false)
        if(!!verificationCode){
            setCode(verificationCode)
        }
        if(codeReceived){
            //bootstrapCodeActivation(verificationCode,check ? referral : '', phone)
        }
        if(auth.authToken && referral.trim() === ''){
            setCheck(false)
        }
        if (auth.authorized) {
            navigate(Routes.root)
        }
    }, [auth.authorized,verificationCode, operatorName, countryName,errorVisible])

    useEffect(() => {
        if((!!localStorage.getItem(localStorageKeys.countryName) && localStorage.getItem(localStorageKeys.countryName) == null) || localStorage.getItem(localStorageKeys.countryName) == operations.yabadoo){
            setHeaderFetching(true)
            axios.get('https://whoer.net/ip_json').then((response) => {
                let data = response.data
                sessionStorage.setItem(localStorageKeys.userIp,data.ip)
                if (data.country == "Cameroon"){//Cameroon Lebanon
                    // localStorage.setItem(localStorageKeys.countryName, operations.aplitv)
                    // setcountryName(operations.aplitv)

                    localStorage.setItem(localStorageKeys.countryName, countryOperator.cameroon.name)
                    setcountryName(countryOperator.cameroon.name)
                    if(data.provider.includes('MTN')){//MTN Energy
                        localStorage.setItem(localStorageKeys.operatorName, countryOperator.cameroon.operators.mtn.name)
                        // document.location.href = 'https://cam.apli.tv/crudAPI_mobile_test/aplitv_getuserinfo_pwa'
                        document.location.href = 'http://mtntv.mtncameroon.net/crudAPI_mobile/aplitv_getuserinfo_pwa'
                    }else if(data.provider.includes('Orange')) {
                        localStorage.setItem(localStorageKeys.operatorName, countryOperator.cameroon.operators.orange.name)
                        document.location.href = 'https://waaat.orange.cm/aplitv/'
                    }else{
                        setHeaderFetching(false)
                    }
                }else if (data.country == "Mozambique"){
                    localStorage.setItem(localStorageKeys.countryName, countryOperator.mozambique.name)
                    setcountryName(countryOperator.mozambique.name)
                    if(!data.provider.includes('Vodacom')){//tmcel network
                        localStorage.setItem(localStorageKeys.operatorName, countryOperator.mozambique.operators.TMCEL.name)
                        document.location.href = 'http://cam.tmcel.co.mz/crudAPI_mobile/aplitv_getuserinfo_pwa'
                        // setHeaderFetching(false)
                    }else{
                        localStorage.setItem(localStorageKeys.operatorName, countryOperator.mozambique.operators.Vodacom.name)
                        document.location.href = 'http://cam.vm.co.mz/crudAPI_mobile/aplitv_getuserinfo_pwa'
                        //setHeaderFetching(false)
                    }
                }else{
                    setHeaderFetching(false)
                }
            }).catch((error) => {
                setHeaderFetching(false)
            });
        }
    },[])

    // useEffect(() => {
    //     // https://iptools-4.top10vpn.com/ip/?genToken=
    //     //https://whoer.net/resolve
    //     //https://whoer.net/ip_json
    //     if((!!localStorage.getItem(localStorageKeys.countryName) && localStorage.getItem(localStorageKeys.countryName) == null) || localStorage.getItem(localStorageKeys.countryName) == operations.yabadoo){
    //         setHeaderFetching(true)
    //         axios.get('https://whoer.net/ip_json').then((response) => {
    //             let data = response.data
    //             setHeaderFetching(false)
    //             if (data.country == "Cameroon"){//Cameroon Lebanon
    //                 // localStorage.setItem(localStorageKeys.countryName, operations.aplitv)
    //                 // setcountryName(operations.aplitv)
    //
    //                 localStorage.setItem(localStorageKeys.countryName, countryOperator.cameroon.name)
    //                 setcountryName(countryOperator.cameroon.name)
    //                 if(data.provider.includes('MTN')){//MTN Energy
    //                     if(isheaderEnrichment){
    //                         document.location.href = 'http://mtntv.mtncameroon.net/crudAPI_mobile/aplitv_getuserinfo_pwa'
    //                     }
    //                     localStorage.setItem(localStorageKeys.headerSet,countryOperator.cameroon.operators.mtn.cuurentOperation)
    //                 }else if(data.provider.includes('Orange')) {
    //                     if (isheaderEnrichment) {
    //                         document.location.href = 'https://waaat.orange.cm/aplitv/'
    //                     }
    //                     localStorage.setItem(localStorageKeys.headerSet, countryOperator.cameroon.operators.orange.cuurentOperation)
    //                 }
    //             }else if (data.country == "Mozambique"){
    //                 localStorage.setItem(localStorageKeys.countryName, countryOperator.mozambique.name)
    //                 setcountryName(countryOperator.mozambique.name)
    //             }
    //         }).catch((error) => {
    //             setHeaderFetching(false)
    //         });
    //     }
    // },[])

    useEffect(() => {
    },[fetch])


    const register = e => {
        e.preventDefault()
        const inputPhoneNumber = phone.length
        if (inputPhoneNumber === phoneNumber.limit) {
            setfocus(false)
            if (auth.authToken === undefined) bootstrapRegistration(phone,check ? referral : '', sessionStorage.getItem(localStorageKeys.number) !== null ? true : false)
            else bootstrapCodeActivation(code,check ? referral : '', phone)
        } else {
            setfocus(true)
        }
    }

    const resetRegister = e => {
        localStorage.removeItem(localStorageKeys.pushToken)
        localStorage.removeItem(localStorageKeys.recevReferral)
        try {
            if ((!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) && Notification.permission === 'granted') || (typeof InstallTrigger !== 'undefined' && Notification.permission === 'granted') || (!!useragent.os.name && useragent.os.name === "Android" && Notification.permission === 'granted')) {
                firebase.messaging().getToken().then(token => firebase.messaging().deleteToken(token))
            }
        } catch (e) {
            //console.log(e)
        }
        setPhone(phoneNumber.prefix)
        setCode('')
        setReferral('')
        resetRegistration()
    }

    const changePhone = (e) => {
        setPhone(e.target.value)
        setfocus(false)
        // setHeaderEnrichmentData(e.target.value)
    }

    const changeCountry = e => {
        if (e === countryOperator.cameroon.name) {
            localStorage.setItem(localStorageKeys.countryName, countryOperator.cameroon.name)
            setcountryName(countryOperator.cameroon.name)
        }
        else if (e === countryOperator.mozambique.name){
            localStorage.setItem(localStorageKeys.countryName, countryOperator.mozambique.name)
            setcountryName(countryOperator.mozambique.name)
        }
        // check if only one operator - set by default
        if(localStorage.getItem(localStorageKeys.countryName) === "Cameroon" && Object.values(countryOperator.cameroon.operators).length === 1){
            setSingleOperator(Object.values(countryOperator.cameroon.operators)[0].name,Object.values(countryOperator.cameroon.operators)[0].cuurentOperation)
        } else if(localStorage.getItem(localStorageKeys.countryName) === "Mozambique" && Object.values(countryOperator.mozambique.operators).length === 1){
            setSingleOperator(Object.values(countryOperator.mozambique.operators)[0].name,Object.values(countryOperator.mozambique.operators)[0].cuurentOperation)
        }else{
            // localStorage.setItem(localStorageKeys.operatorName, operations.yabadoo)
            // localStorage.removeItem(localStorageKeys.currentOperation)
            // setoperatorName(operations.yabadoo)
            localStorage.removeItem(localStorageKeys.operatorName)
            setoperatorName(operations.yabadoo)
        }
    }

    const setSingleOperator = (name,currentOper) => {
        setoperatorName(name)
        // localStorage.setItem(localStorageKeys.currentOperation, currentOper)
        localStorage.setItem(localStorageKeys.operatorName, name)
        window.location.reload()
    }

    const changeOperation = e => {
        if (countryName === countryOperator.cameroon.name) {
            Object.values(countryOperator.cameroon.operators).forEach((item) => {
                if (e === item.name) {
                    setoperatorName(item.name)
                    // localStorage.setItem(localStorageKeys.currentOperation, item.cuurentOperation)
                    localStorage.setItem(localStorageKeys.operatorName, item.cuurentOperation)
                }
            })
        }
        else if (countryName === countryOperator.mozambique.name) {
            Object.values(countryOperator.mozambique.operators).forEach((item) => {
                if (e === item.name) {
                    setoperatorName(item.name)
                    // localStorage.setItem(localStorageKeys.currentOperation, item.cuurentOperation)
                    localStorage.setItem(localStorageKeys.operatorName, item.cuurentOperation)
                }
            })
        }
        localStorage.setItem(localStorageKeys.operatorName, e)
        window.location.reload()
    }

    const countryOptions = Object.values(countryOperator).map((item, index) => {
        return (
            <Select.Option key={index} value={item.name}>{item.name}</Select.Option>
            //<option key={index} value={item.name}>{item.name}</option>
        )
    })
    const operatorOptions = countryName === countryOperator.cameroon.name ? Object.values(countryOperator.cameroon.operators).map((item, index) => {
            return (
                <Select.Option key={index} value={item.name}>{item.name}</Select.Option>
                //<option key={index} value={item.name}>{item.name}</option>
            )
        })
        : countryName === countryOperator.mozambique.name ?
                Object.values(countryOperator.mozambique.operators).map((item, index) => {
                    return (
                        <Select.Option key={index} value={item.name}>{item.name}</Select.Option>
                        //<option key={index} value={item.name}>{item.name}</option>
                    )
                }) : null

    const checkCountry = () => {
        switch (countryName) {
            case countryOperator.cameroon.name:
                return (
                    <img className="require-image" alt="" src={require('../../assets/img/icons/flag-cameroon-800.png')}/>
                )
            case countryOperator.mozambique.name:
                return (
                    <img className="require-image" alt="" src={require('../../assets/img/icons/1024px-Flag_of_Mozambique.svg.png')}/>
                )
            default:
                return null
        }
    }

    return (
        !!!localStorage.getItem(localStorageKeys.acceptPolicy) && currentOperation === operations.vodacom ? /*to accept privacy and policy for Vodacom opr. before registration*/ <PrivacyPolicy/> :
            <div className="login-container" style={{backgroundImage: `url(${bg})`}}>
            {fetch || headerFetching ?
                <div className="fetch-app-pop">
                    <img width="8%" src={loadingImages} alt="loadingImages" />
                </div>
                : null }
            {/*<img src={loginBackground} alt="logo" style={{position:'absolute',width:'100%',height:'100%'}}/>*/}
            <div className="row mx-0" /*for iSHow style={{position:'absolute',right:'8%',top:'35%'}}*/>
                <div className="col-12 col-lg-5 login-container-left my-auto">
                    <img src={wideLogo} alt="logo" className='menu-logo mx-auto' width={400}/>
                    <h2>{localize('loginTextFirst')} {localize('loginTextSecond')}</h2>
                    {/*<h1>{localize('loginTextSecond')}</h1>*/}
                </div>
                {headEnr ? <div className="col-12 col-lg-6 my-auto">
                    <div className="card card-signin my-5">
                        <h3 className='center my-4'>{localize('register')}</h3>



                        {/*(localStorage.getItem(localStorageKeys.number) === null) && */(isYabadooOperation) ?
                            <div className="selectWrapper">
                                {!!!sessionStorage.getItem(localStorageKeys.number) ? checkCountry() : null}
                                {/*<select className="selectBox" value={countryName} onChange={changeCountry}>*/}
                                {/*    <option value={operations.yabadoo} disabled>{localize('chooseyourCountry')}</option>*/}
                                {/*    {countryOptions}*/}
                                {/*</select>*/}
                                <Select value={countryName} disabled={!!sessionStorage.getItem(localStorageKeys.number)} className="settings-dropdown" style={{width: "100%",height: "48px",padding:"9px 8px 8px 8px"}} onChange={val => changeCountry(val)}>
                                    <Select.Option value={operations.yabadoo}  disabled>{localize('chooseyourCountry')}</Select.Option>
                                    {countryOptions}
                                </Select>
                            </div> : null
                        }

                        {/*(localStorage.getItem(localStorageKeys.number) === null) &&*/ (isYabadooOperation) ?

                            <div className="selectWrapper">
                                <Select value={operatorName} disabled={!!sessionStorage.getItem(localStorageKeys.number)} className="settings-dropdown" style={{width: "100%",height: "48px",padding:"9px 8px 8px 8px"}} onChange={val => changeOperation(val)}>
                                    <Select.Option value={operations.yabadoo} disabled>{localize('chooseyourOperator')}</Select.Option>
                                    {operatorOptions}
                                </Select>
                                {/*<select className="selectBox" value={operatorName} disabled={countryName === operations.yabadoo} onChange={changeOperation}>*/}
                                {/*    <option value={operations.yabadoo} disabled>{localize('chooseyourOperator')}</option>*/}
                                {/*    {operatorOptions}*/}
                                {/*</select>*/}
                            </div> : null
                        }
                        {sessionStorage.getItem(localStorageKeys.number) !== null ? <>
                                <div className="header-enrch-number">
                                    {checkCountry()}
                                    <p>{sessionStorage.getItem(localStorageKeys.number)}</p>
                                </div>
                                {referralEnabled && sessionStorage.getItem(localStorageKeys.af) !== 'one10labs' ? <div className="form-label-group-checkbox" style={{margin:'0rem 1rem'}}>
                                    <label className="referral-box">
                                        <input
                                            type="checkbox"
                                            className='checkbox-referral'
                                            checked={check}
                                            onChange={() => setCheck(!check)}
                                            disabled={auth.authToken || auth.fetching}
                                        />
                                        {localize('referral_code_checkbox')}
                                    </label>
                                    {check ? (
                                            <div className="form-label-group">
                                                <input type="text" className="form-control" style={{caretColor:"white"}} placeholder={localize('enter_referral_code')} id="inputCode"
                                                       value={referral} onChange={e => setReferral(e.target.value)} disabled={auth.authToken || auth.fetching} autoFocus/>
                                                <label className="phone-number" htmlFor="inputCode">{referral === '' ? localize('enter_referral_code') : localize('referral_code')}</label>
                                            </div>)
                                        : null}
                                </div> : null}

                                <button id='btn-startWatching' className="btn btn-lg btn-primary btn-block"
                                        style={{display:'flex',alignItems:'center',justifyContent:'center',backgroundColor:"#253d50",borderColor:"#253d50",fontSize:'18px',margin:'0rem 1rem',width:'unset',height:'50px',borderRadius:'25px'}}
                                        onClick={() => bootstrapRegistration(sessionStorage.getItem(localStorageKeys.number),check ? referral : '',false )}
                                        disabled={auth.fetching}
                                >
                                    {!auth.fetching ? <FaPlay style={{marginRight:'0.5rem'}}/> : null}
                                    {auth.fetching ? <span className="spinner-border mr-3"/> : null}
                                    {localize('startWatching')}
                                </button>
                                {/*<p className="freeBundle-text">{localize('journey_text')}</p>*/}
                                <p className="freeMsg-text">{localize('journey_text')}</p>

                            </>
                            : null
                        }

                        {(currentOperation === (operations.yabadoo || operations.mtnCameroon || operations.tmcel || operations.orange || operations.vodacom)) ? null : (
                            <div className="card-body" hidden={(!!sessionStorage.getItem(localStorageKeys.number)) || operation === null || operation === operation.yabadoo}>
                                {/*<div className="card-body">*/}
                                <form className="form-signin" onSubmit={register} autoComplete="off">
                                    <div className="form-label-group">
                                        {/*<span className='proxy-label'>*/}
                                        {/*    <select className='proxy-select'>*/}
                                        {/*        <option>MTN</option>*/}
                                        {/*        <option>Syriatel</option>*/}
                                        {/*    </select>*/}
                                        {/*    <img src={require('../../assets/img/logos/mtn-logo.jpg')} alt="" width={30} height={30}/>*/}
                                        {/*</span>*/}
                                        {/*<input type="text" className="form-control login-number-input" placeholder={localize('phoneNumber')} id="inputPhone" disabled={!!auth.authToken}*/}
                                        {/*       value={phone} onChange={e => e.target.value.match(/^(\s*|\d+)$/) ? setPhone(e.target.value) : phone}*/}
                                        {/*       required autoFocus/>*/}
                                        {/*<label htmlFor="inputPhone" className='login-number-label'>{localize('phoneNumber')}</label>*/}

                                        <input type="text" className="form-control" placeholder={localize('phoneNumber')} disabled={!!auth.authToken || auth.fetching}
                                               value={phone} maxLength={phoneNumber.limit}
                                               onChange={e => e.target.value.match(/^(\s*|\d+)$/) && e.target.value.slice(0, 3) === phoneNumber.prefix ? changePhone(e) : phone}
                                               required autoFocus/>

                                        {!focus ? <label htmlFor="inputPhone">{localize('phoneNumber')}</label> :
                                            <label className="uplabel" htmlFor="inputPhone">{localize('notValidphoneNumberHint')}</label>}


                                        {referralEnabled && sessionStorage.getItem(localStorageKeys.af) !== 'one10labs' ? <div className="form-label-group-checkbox">
                                            <label className="referral-box">
                                                <input
                                                    type="checkbox"
                                                    className='checkbox-referral'
                                                    checked={check}
                                                    onChange={() => setCheck(!check)}
                                                    disabled={auth.authToken || auth.fetching}
                                                />
                                                {localize('referral_code_checkbox')}
                                            </label>
                                        </div> : null}
                                    </div>
                                    {check ? (
                                        <div className="form-label-group">
                                            <input type="text" className="form-control" style={{caretColor:"white"}} placeholder={localize('enter_referral_code')} id="inputCode"
                                                   value={referral} onChange={e => setReferral(e.target.value)} disabled={auth.authToken || auth.fetching} autoFocus/>
                                            <label className="phone-number" htmlFor="inputCode">{referral === '' ? localize('enter_referral_code') : localize('referral_code')}</label>
                                        </div>
                                    ) : null}
                                    {auth.authToken ? (
                                        <div className="form-label-group">
                                            <input type="text" className="form-control" style={{caretColor:"white"}} placeholder={localize('verificationCode')} id="inputCode1"
                                                   value={code} maxLength={4} onChange={e => setCode(e.target.value)} disabled={codeReceived || auth.fetching} required autoFocus/>
                                            <label className="phone-number" htmlFor="inputCode1">{localize('verificationCode')}</label>
                                        </div>

                                    ) : null}

                                    <button type='submit'
                                            id={auth.authToken ? 'btn-confirm' : 'btn-register'}
                                            style={{backgroundColor:"#253d50",borderColor:"#253d50"}}
                                            className="btn btn-lg btn-primary btn-block text-uppercase d-flex justify-content-center align-items-center"
                                            disabled={auth.fetching || phone === phoneNumber.prefix}>
                                        {auth.fetching ? <span className="spinner-border mr-3"/> : null}
                                        {auth.authToken ? localize('submit') : localize('login')}
                                    </button>

                                    {auth.authToken ? (
                                        <button className="btn btn-lg btn-primary btn-block text-uppercase"
                                                id='btn-reset'
                                                style={{backgroundColor:"#253d50",borderColor:"#253d50"}}
                                                onClick={resetRegister}
                                                disabled={auth.fetching}
                                        >
                                            {localize('reset')}
                                        </button>
                                    ) : null}
                                    <p className="freeBundle-text">{localize('journey_text')}</p>
                                </form>
                            </div>
                        )}
                    </div>
                </div> : null}
            </div>
            <Footer/>
        </div>
    )
}


export default compose(WithAuth, WithSettings)(Login)
